export const sliderItems = [
    {
        id: 1,
        img: "https://i.ibb.co/7tcjFGt/background-4.png",
        title: "SUMMER SALE",
        desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg: "89c1fa",
        cat: "Womens_Shirt"
    },
    {
        id: 2,
        img: "https://i.ibb.co/ZWRLWJ5/background-5.png",
        title: "AUTUMN COLLECTION",
        desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg: "8898a8",
        cat: "Mens_Suit"
    },
    {
        id: 3,
        img: "https://i.ibb.co/yVfJtYk/background-6.png",
        title: "LOUNGE WEAR LOVE",
        desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg: "faef8c",
        cat: "Womens_Shirt"
    },
    {
        id: 4,
        img: "https://i.ibb.co/vwDGQnx/background-1.png",
        title: "POPULAR SALE",
        desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg: "fa8989",
        cat: "Womens_Dress" 
    },
];

export const categories = [
    {
        id: 1,
        img: "https://i.ibb.co/HnF7wj1/isaac-ramirez-UNSj7-Bt-OK0-Q-unsplash.jpg", 
        title: "LIGHT JACKETS",
        cat: "Jacket"
    },
    {
        id: 2,
        img: "https://i.ibb.co/WWv27Hk/Women-dress.jpg", 
        title: "LOUNGEWEAR LOVE",
        cat: "Womens_Dress"
    },
    {
        id: 3,
        img: "https://i.ibb.co/nL9ZzQj/Purple-T-shirt-2.jpg", 
        title: "SHIRT STYLE",
        cat: "T-Shirt"
    },
];

export const popularProducts = [
    {
        id: 1,
        img: "https://i.ibb.co/P5rJmsL/faith-yarn-Wr0-Tp-Kqf26s-unsplash-removebg-preview.png"
    },
    {
        id: 2,
        img: "https://i.ibb.co/hBhyFqM/Purple-T-shirt-removebg-preview.png"
    },
    {
        id: 3,
        img: "https://i.ibb.co/P5CCMbm/matt-moloney-Nhbv-Saq-GExs-unsplash-removebg-preview.png"
    },
    {
        id: 4,
        img: "https://i.ibb.co/FwQpr3G/Mavi-T-Shirt-removebg-preview.png"
    },
    {
        id: 5,
        img: "https://i.ibb.co/vZcb3zf/Cross-Bag-removebg-preview.png"
    },
    {
        id: 6,
        img: "https://i.ibb.co/FstxLW4/Shoes-removebg-preview.png"
    },
    {
        id: 7,
        img: "https://i.ibb.co/GQmnT4g/laura-chouette-Ryc-Le-Ddr-WJ0-unsplash-removebg-preview.png"
    },
    {
        id: 8,
        img: "https://i.ibb.co/4Tvs8KG/curology-ZIih-Tgf5u-Gg-unsplash-removebg-preview.png"
    },
];